import { HTMLAttributes, forwardRef } from 'react';

export interface CardProps extends HTMLAttributes<HTMLDivElement> { }

export const Card = forwardRef<HTMLDivElement, CardProps>(
    ({ className, ...props }, ref) => {
        return (
            <div
                ref={ref}
                className={`bg-white rounded-lg border shadow-sm ${className}`}
                {...props}
            />
        );
    }
);

Card.displayName = 'Card';
